export { default } from './component';


// WEBPACK FOOTER //
// ./components/Agile/issue/index.js